import { render, staticRenderFns } from "./NotesPanel.vue?vue&type=template&id=53be8a4c&"
import script from "./NotesPanel.vue?vue&type=script&lang=js&"
export * from "./NotesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports